/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leave_Your_Email_For_A_ResponsInputs */

const en_leave_your_email_for_a_respons = /** @type {(inputs: Leave_Your_Email_For_A_ResponsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leave your email for a response`)
};

const es_leave_your_email_for_a_respons = /** @type {(inputs: Leave_Your_Email_For_A_ResponsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deja tu correo para recibir respuesta`)
};

const fr_leave_your_email_for_a_respons = /** @type {(inputs: Leave_Your_Email_For_A_ResponsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laissez votre e-mail pour une réponse`)
};

const de_leave_your_email_for_a_respons = /** @type {(inputs: Leave_Your_Email_For_A_ResponsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinterlasse deine E-Mail für eine Antwort`)
};

const ja_leave_your_email_for_a_respons = /** @type {(inputs: Leave_Your_Email_For_A_ResponsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返信用のメールアドレスを残す`)
};

const zh_leave_your_email_for_a_respons = /** @type {(inputs: Leave_Your_Email_For_A_ResponsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请留下您的电子邮箱以便我们回复`)
};

const ar_leave_your_email_for_a_respons = /** @type {(inputs: Leave_Your_Email_For_A_ResponsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اترك بريدك الإلكتروني للحصول على رد`)
};

const id_leave_your_email_for_a_respons = /** @type {(inputs: Leave_Your_Email_For_A_ResponsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinggalkan email Anda untuk mendapatkan tanggapan`)
};

const it_leave_your_email_for_a_respons = /** @type {(inputs: Leave_Your_Email_For_A_ResponsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lascia la tua e-mail per una risposta`)
};

const ru_leave_your_email_for_a_respons = /** @type {(inputs: Leave_Your_Email_For_A_ResponsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оставьте свой email для получения ответа`)
};

const pt_leave_your_email_for_a_respons = /** @type {(inputs: Leave_Your_Email_For_A_ResponsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixe o seu e-mail para receber uma resposta`)
};

const ko_leave_your_email_for_a_respons = /** @type {(inputs: Leave_Your_Email_For_A_ResponsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`답변을 받을 이메일을 남겨주세요`)
};

/**
* | output |
* | --- |
* | "Leave your email for a response" |
*
* @param {Leave_Your_Email_For_A_ResponsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const leave_your_email_for_a_respons = /** @type {((inputs?: Leave_Your_Email_For_A_ResponsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leave_Your_Email_For_A_ResponsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_leave_your_email_for_a_respons(inputs)
	if (locale === "es") return es_leave_your_email_for_a_respons(inputs)
	if (locale === "fr") return fr_leave_your_email_for_a_respons(inputs)
	if (locale === "de") return de_leave_your_email_for_a_respons(inputs)
	if (locale === "ja") return ja_leave_your_email_for_a_respons(inputs)
	if (locale === "zh") return zh_leave_your_email_for_a_respons(inputs)
	if (locale === "ar") return ar_leave_your_email_for_a_respons(inputs)
	if (locale === "id") return id_leave_your_email_for_a_respons(inputs)
	if (locale === "it") return it_leave_your_email_for_a_respons(inputs)
	if (locale === "ru") return ru_leave_your_email_for_a_respons(inputs)
	if (locale === "pt") return pt_leave_your_email_for_a_respons(inputs)
	return ko_leave_your_email_for_a_respons(inputs)
});